import { RedirectionUrls, RedirectStatus } from "./ClientRedirect.types";
import { RedirectAlreadyRedirected } from "./RedirectAlreadyRedirected";
import { RedirectDestinationActions } from "./RedirectDestinationActions";
import { RedirectFailed } from "./RedirectFailed";
import { RedirectSpinner } from "./RedirectSpinner";

type RedirectStatusContentProps = {
  status: RedirectStatus | null;
  os: string;
  redirectionUrls: RedirectionUrls;
};

/**
 * What the fallback layout shows once the automatic redirect is out of the
 * picture — still in flight, already used, or failed.
 */
export function RedirectStatusContent({
  status,
  os,
  redirectionUrls,
}: RedirectStatusContentProps) {
  if (!status) return <RedirectSpinner />;

  return (
    <div className="flex flex-col items-center gap-4">
      {status === "alreadyRedirected" ? (
        <RedirectAlreadyRedirected os={os} iosUrl={redirectionUrls.ios} />
      ) : (
        <RedirectFailed />
      )}
      <RedirectDestinationActions
        os={os}
        iosUrl={redirectionUrls.ios}
        androidUrl={redirectionUrls.android}
        webUrl={redirectionUrls.web}
      />
    </div>
  );
}
